export enum USER_TAGS {
  VIP = 'VIP',
}

export interface IUserProfile {
  id?: string | null;
  userType?: string | null;
  rawUserType?: string | null;
  servicePointId?: string | null;
  servicePointIds?: string[] | null;
  fullName?: string | null;
  birthday?: string | null;
  isBlocked?: boolean | null;
  createdAt?: string | null;
  socialNetworks?: IUserProfile.ISocialNetwork[] | null;
  blockingReasonDescription?: string | null;
  blockedAt?: string | null;
  mainPhone?: string | null;
  isDeleted?: boolean | null;
  hasContacts?: boolean | null;
  yandexId?: string | null;
  tags: USER_TAGS[] | null;
}

export namespace IUserProfile {
  export interface ISocialNetwork {
    name?: string | null;
    url?: string | null;
  }
}
